import React from "react";
import { Redirect } from "react-router-dom";
import Header from "../Header";
import Common from "./../Common";
import logo_img from "./../assets/images/notfound.jpg";
import { Container } from "react-bootstrap";
import ImageDesertSun from "../assets/images/desert-soon.png";
import ImageDesertMoon from "../assets/images/desert-moon.png";
class Unauthorized extends Common {
  constructor(props) {
    super(props);
    this.state = {};
  }
  back() {
    window.location.href = "/login/";
  }
  render() {
    if (this.state.redirect) {
      return <Redirect to={"/login"} />;
    }
    return (
      <>
        {" "}
        <div className="mainContent-panel-wrap" style={{ overflow: "auto" }}>
          <Header
            brecum_name="404"
            brecum_page={
              "404"
            }
          />
          <Container>
            <div className="page-content pt-3">
              <div class="no-content _404">
                <div class="wrap404">
                  <figure>
                    <img
                      id="imgNight"
                      src={ImageDesertSun}
                      alt=""
                      class="d-none"
                    />
                    <img id="imgDay" alt="" src={ImageDesertMoon} class="" />
                  </figure>
                  <div class="title">Sorry, this page isn’t available.</div>
                  <div class="sub-title">
                    The page you are looking for couldn’t be found.
                    <br />
                    For help, visit our{" "}
                    <a class="muBtn _link txt-base p-0" href="">
                      Help Centre
                    </a>
                    .
                  </div>
                  <div
                    class="muBtn _blue mt-4"
                    data-bs-toggle="modal"
                    data-bs-target="#subscription-modal"
                  >
                    Go back
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </>
    );
  }
  componentDidMount() {
    if (!localStorage.getItem("userLogin")) {
      this.setState({ redirect: true });
    }
  }
}

export default Unauthorized;
